import React from 'react';
import { StarIcon } from 'lucide-react';
import { Reveal } from '../Reveal';
import { Accent, SectionHeading } from './SectionHeading';
import { bonuses } from '../../data/content';

/** Section 9 — the 5 bonuses, Bonus #5 highlighted. */
export function BonusesSection() {
  return <section aria-labelledby="bonuses-heading" className="bg-brand-blush px-5 py-16 lg:px-8 lg:py-24" data-id="element-28" data-mp="1bk2eo1kwk6q9">
      <div className="mx-auto max-w-5xl" data-id="element-29" data-mp="wnbbdh83yavd">
        <SectionHeading id="bonuses-heading" title={<>
              And You’ll Also Get <Accent data-id="element-31" data-mp="11nfw5jg1trre">5 Professional Bonuses</Accent> 🎁
            </>} data-id="element-30" data-mp="wli3jylrdkls" />

        <ol className="mt-12 grid gap-6 md:grid-cols-2" role="list" data-id="element-32" data-mp="nny2oqrt5qbp">
          {bonuses.map((bonus, index) => <li key={bonus.number} className={bonus.featured ? 'md:col-span-2' : ''} data-id="element-33" data-mp="snkdktk5yuhc" data-mpi={index}>
              <Reveal delay={index % 2 * 0.05} className="h-full" data-id="element-34" data-mp="2i0xq362fjotj">
                {bonus.featured ? <article className="relative flex h-full flex-col overflow-hidden rounded-[22px] border-2 border-brand-gold/50 bg-white shadow-[0_40px_80px_-44px_rgba(176,138,46,0.6)] md:flex-row" data-id="element-35" data-mp="2mypmode0rz42">
                    <div className="flex flex-col justify-center px-7 py-7 md:w-[38%] md:px-9" style={{
                backgroundColor: bonus.accent
              }} data-id="element-36" data-mp="1g45wdb17tk90">
                      <p className="font-body text-[11px] font-bold uppercase tracking-[0.2em] text-brand-charcoal/75" data-id="element-37" data-mp="1p0n8aghelm5t">
                        {bonus.number}
                      </p>
                      <p className="mt-3 inline-flex w-fit items-center gap-1.5 rounded-full bg-brand-charcoal px-3.5 py-1.5 font-body text-[11px] font-bold uppercase tracking-[0.14em] text-brand-butter" data-id="element-38" data-mp="x97cpwxvcp3g">
                        <StarIcon className="h-3.5 w-3.5 fill-brand-butter" strokeWidth={1.5} aria-hidden="true" data-id="element-39" data-mp="166rj1kal9bkx" />
                        For Busy Brow Educators
                      </p>
                    </div>
                    <div className="flex flex-1 flex-col justify-center px-7 py-8 md:px-10" data-id="element-40" data-mp="2hplsdj536ydr">
                      <h3 className="font-display text-[1.75rem] font-bold leading-snug text-brand-charcoal sm:text-[2rem]" data-id="element-41" data-mp="2pq05xzg8bz4p">
                        {bonus.title}
                      </h3>
                      <p className="mt-3 text-[15px] leading-relaxed text-brand-charcoal/70" data-id="element-42" data-mp="2ypeyr5jvclsd">{bonus.description}</p>
                    </div>
                  </article> : <article className="flex h-full flex-col overflow-hidden rounded-[22px] border border-brand-charcoal/8 bg-white shadow-[0_24px_50px_-36px_rgba(90,70,40,0.45)]" data-id="element-43" data-mp="261iyxrz06drd">
                    <div className="px-7 py-3" style={{
                backgroundColor: bonus.accent
              }} data-id="element-44" data-mp="2fxcap94we383">
                      <p className="font-body text-[11px] font-bold uppercase tracking-[0.2em] text-brand-charcoal/75" data-id="element-45" data-mp="2kpvzl291cks7">
                        {bonus.number}
                      </p>
                    </div>
                    <div className="flex flex-1 flex-col px-7 py-7 sm:px-8" data-id="element-46" data-mp="1s78jk18wbvxz">
                      <h3 className="font-display text-[1.5rem] font-bold leading-snug text-brand-charcoal" data-id="element-47" data-mp="1kpacs4i3myyg">
                        {bonus.title}
                      </h3>
                      <p className="mt-2.5 text-[14px] leading-relaxed text-brand-charcoal/65" data-id="element-48" data-mp="1aquk3x3fbhmu">{bonus.description}</p>
                    </div>
                  </article>}
              </Reveal>
            </li>)}
        </ol>
      </div>
    </section>;
}